import { render, staticRenderFns } from "./ChatGameOrder.vue?vue&type=template&id=09fdc81c&"
import script from "./ChatGameOrder.vue?vue&type=script&lang=js&"
export * from "./ChatGameOrder.vue?vue&type=script&lang=js&"
import style0 from "./ChatGameOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports